import React, { useEffect, useState } from "react";
import {
  deleteProfilePhoto,
  getProfilePhotos,
  ProfilePhoto,
} from "../../services/profilePhotoService";
import DeleteModal from "../../components/DeleteModal";

const ProfilePhotosList: React.FC = () => {
  const [photos, setPhotos] = useState<ProfilePhoto[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState<ProfilePhoto | null>(null);

  const fetchPhotos = async () => {
    const list = await getProfilePhotos();
    setPhotos(list);
  };

  const handleDelete = async () => {
    if (!itemToDelete) return;

    try {
      await deleteProfilePhoto(itemToDelete.id);
      setError(null);
      setIsDeleteModalOpen(false);
      setItemToDelete(null);
      fetchPhotos();
    } catch (err: any) {
      console.error(err);
      setError(
        err.response?.data?.message || "Cannot delete this profile photo."
      );
    }
  };

  useEffect(() => {
    fetchPhotos();
  }, []);

  const filteredPhotos = photos.filter((photo) =>
    photo.name.toLowerCase().includes(searchQuery.trim().toLowerCase())
  );

  return (
    <div className="p-6">
      <h1 className="text-2xl font-bold mb-4">Profile Photos</h1>

      <input
        type="text"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        placeholder="Search by name..."
        className="border rounded px-3 py-2 mb-4 w-full max-w-sm"
      />

      {error && <div className="mb-4 text-red-600 font-semibold">{error}</div>}
      <div className="grid grid-cols-3 gap-4">
        {filteredPhotos.map((photo) => (
          <div
            key={photo.id}
            className="border p-4 rounded flex flex-col items-center"
          >
            <img
              src={photo.photoUrl}
              alt={photo.name}
              className="w-24 h-24 rounded-full mb-2 object-cover"
            />
            <div className="font-semibold">{photo.name}</div>
            <div className="flex gap-2 mt-2">
              <button
                onClick={() => {
                  setItemToDelete(photo);
                  setIsDeleteModalOpen(true);
                }}
                className="text-red-600"
              >
                Remove
              </button>
            </div>
          </div>
        ))}
      </div>

      <DeleteModal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        onConfirm={handleDelete}
        itemName={itemToDelete?.name || ""}
        itemType="profile photo"
      />
    </div>
  );
};

export default ProfilePhotosList;
